export enum Currency {
  EUR = "EUR",
  REAL = "BRL",
}

const currencyLocales: Record<Currency, string> = {
  [Currency.EUR]: "pt-PT",
  [Currency.REAL]: "pt-BR",
}
export const getCurrencySymbol = (currency: Currency): string => {
  const formatter = new Intl.NumberFormat(currencyLocales[currency], {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  try {
    const parts = formatter.formatToParts(0)
    const symbolPart = parts.find((p) => p.type === "currency")
    return symbolPart ? symbolPart.value : currency
  } catch {
    // Fallback: just return the currency code if something goes wrong
    return currency
  }
}

export const formatCurrencyBRL = (
  amount: string | number | null | undefined,
  currency: Currency,
): string => {
  if (amount === null || amount === undefined) {
    return ""
  }

  const numericAmount = typeof amount === "string" ? Number(amount) : amount

  if (Number.isNaN(numericAmount)) {
    return ""
  }

  return new Intl.NumberFormat(currencyLocales[currency], {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numericAmount)
}

/**
 * Returns Intl.NumberFormat parts so that the currency symbol can be styled separately.
 */
export const formatCurrencyParts = (
  amount: string | number | null | undefined,
  currency: Currency,
): Intl.NumberFormatPart[] => {
  if (amount === null || amount === undefined) return []

  const numericAmount = typeof amount === "string" ? Number(amount) : amount
  if (Number.isNaN(numericAmount)) return []

  const formatter = new Intl.NumberFormat(currencyLocales[currency], {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  try {
    return formatter.formatToParts(numericAmount)
  } catch {
    // Fallback to a single literal if formatToParts is not supported for some reason
    return [{ type: "literal", value: formatter.format(numericAmount) }]
  }
}

export function parseCurrency(
  str?: string,
  fallback: Currency = Currency.EUR,
): Currency {
  if (!str) return fallback

  const normalized = str.trim().toUpperCase()
  if (normalized === "EUR" || normalized === "€") return Currency.EUR
  if (normalized === "BRL" || normalized === "REAL" || normalized === "R$")
    return Currency.REAL
  return fallback
}
